import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';
import type { VideoType } from '@/types/video';

const CATEGORIES: { type: VideoType; title: string; desc: string; image: string }[] = [
  {
    type: 'movie',
    title: '电影频道',
    desc: '院线级热门大片，动作、悬疑、科幻一网打尽',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20movie%20channel%20banner%2C%20empty%20vintage%20cinema%20hall%20with%20glowing%20red%20seats%20and%20a%20bright%20screen%2C%20deep%20navy%20and%20amber%20tones%2C%20dramatic%20atmospheric%20mood%2C%20highly%20detailed%2C%20no%20text&width=800&height=520&seq=cat-entry-movie&orientation=landscape',
  },
  {
    type: 'tv',
    title: '电视剧频道',
    desc: '古装权谋、都市情感、悬疑追凶，熬夜也要追完',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20tv%20series%20channel%20banner%2C%20a%20cozy%20living%20room%20at%20night%20with%20a%20large%20glowing%20tv%20screen%20and%20city%20lights%20outside%2C%20deep%20teal%20and%20warm%20amber%20tones%2C%20dramatic%20atmospheric%20mood%2C%20highly%20detailed%2C%20no%20text&width=800&height=520&seq=cat-entry-tv&orientation=landscape',
  },
  {
    type: 'variety',
    title: '综艺频道',
    desc: '音乐竞演、户外真人秀、脱口秀，轻松快乐不停歇',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20variety%20show%20channel%20banner%2C%20a%20vibrant%20tv%20studio%20stage%20with%20colorful%20spotlights%20and%20confetti%2C%20vivid%20orange%20and%20deep%20navy%20tones%2C%20energetic%20playful%20mood%2C%20highly%20detailed%2C%20no%20text&width=800&height=520&seq=cat-entry-variety&orientation=landscape',
  },
];

export default function CategoryEntrances() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-12 md:px-8 md:py-16">
      <div className="mb-6">
        <span className="font-label inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-accent-600">
          <span className="h-1 w-1 rounded-full bg-accent-500" />
          分类导航
        </span>
        <h2 className="font-heading mt-2 text-xl font-bold text-foreground-950 md:text-2xl">按分类快速进入</h2>
        <p className="mt-1.5 text-sm text-foreground-600">挑选你喜欢的内容类型，一键进入对应频道浏览全部资源</p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {CATEGORIES.map((category) => {
          const count = videos.filter((item) => item.type === category.type).length;
          return (
            <Link
              key={category.type}
              to={`/category/${category.type}`}
              className="group relative block h-52 overflow-hidden rounded-lg border border-background-200/80 transition-all duration-300 hover:border-primary-300 md:h-60"
            >
              <img
                src={category.image}
                alt={`${category.title}入口`}
                title={`${category.title} - 91视频在线`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/45 to-foreground-950/10" />
              <div className="absolute inset-x-0 bottom-0 p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-lg font-bold text-background-50">{category.title}</h3>
                  <span className="font-label rounded-full bg-accent-500 px-2.5 py-1 text-[11px] font-bold text-primary-950">
                    {count} 部
                  </span>
                </div>
                <p className="mt-1.5 text-xs leading-relaxed text-background-200">{category.desc}</p>
                <span className="font-label mt-3 inline-flex items-center gap-1 text-xs font-semibold text-accent-300">
                  浏览全部
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}